<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>

<nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
	<!-- <nav class="navbar navbar-expand-lg navbar-dark bg-primary"> -->
	<a class="navbar-brand col-sm-3 col-md-2 mr-0">
	  <img
		class="brand-logo"
		src="./../../assets/images/logo.png"
		height="50px"
		alt="Logo"
	  />
	  Lycée Marcelle Pardé
	</a>
  </nav>
  
<div class="container-contact100">
	<main role="main" class="col-md-9 ml-sm-auto col-lg-10">

  <ng-container *ngIf="show">
	<!-- <div class="container-contact100"id="questionnaire"> -->
		<div class="wrap-contact100">
			<form class="contact100-form validate-form">
				<span class="contact100-form-title">
					Restaurant scolaire du Lycée Marcelle Pardé 
				</span>

				<div class="wrap-input100 validate-input" data-validate="Entrez votre nom de famille, ex: Pardée">
					<input class="input100"  formControlName="newValue"  id="name" type="text" name="name" placeholder="Nom " #nom>
					<label class="label-input100" for="name">
						<span class="lnr lnr-user"></span>
					</label>
				</div>
				
				<div class="wrap-input100 validate-input" data-validate="Entrez votre prénom, ex: Marcelle ">
					<input class="input100"  formControlName="newValue"  id="firstname" type="text" name="firstname" placeholder="Prénom" #prenom>
					<label class="label-input100" for="firsname">
						<span class="lnr lnr-user"></span>
					</label>
				</div>

				<div class="wrap-input100 validate-input" data-validate = "Example, 1ère ">
					<input class="input100"  formControlName="newValue" id="classe" type="text" name="classe" placeholder="Classe" #classe>
					<label class="label-input100" for="classe">
						<span class="lnr lnr-envelope"></span>
					</label>
				</div>
				
				<div class="wrap-input100 validate-input" data-validate = "Example, 1 ">
					<input class="input100"  formControlName="newValue" id="table" type="text" name="table" placeholder="Table" #table>
					<label class="label-input100" for="table">
						<span class="lnr lnr-envelope"></span>
					</label>
				</div>
				
				<mat-checkbox class="example-margin">
					<p>J'autorise l'enregistrement de mes données sur  <br />
					<a href="https://firebase.google.com/products/firestore?gclid" style="color: blue;">Cloud Firestore</a> pour une durée fixe d'un mois.</p></mat-checkbox>
				
				<div class="container-contact100-form-btn">
					<div class="wrap-contact100-form-btn">
						<div class="contact100-form-bgbtn"></div>
						<button (click)="onSubmit(prenom.value, nom.value, table.value, classe.value);hideQuestions();" class="contact100-form-btn">
							Enregistrer
						</button>
					</div>
				</div>
			</form>
		</div>
	<!-- </div> -->
  </ng-container>
  <ng-container *ngIf="!show">
	<div class="container-contact100"id="questionnaire">
		<img  src="./../../assets/images/logo.jfif" alt="School logo" width=200 height=500>
		<div class="wrap-contact100">
			<form class="contact100-form validate-form"  [formGroup]="this.form">
				<span class="contact100-form-title">
					Merci pour votre participation ! 
				</span>
			</form>
		</div>
	</div>
  </ng-container>

</main>
</div>

